module.exports = __webpack_public_path__ + "static/media/HUN.73545643.svg";